import { render, staticRenderFns } from "./public-products-container.vue?vue&type=template&id=3fa20b35&scoped=true&lang=pug"
import script from "./public-products-container.js?vue&type=script&lang=js&external"
export * from "./public-products-container.js?vue&type=script&lang=js&external"
import style0 from "./public-products-container.vue?vue&type=style&index=0&id=3fa20b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa20b35",
  null
  
)

export default component.exports